import { useEffect } from "react";

// Title, description, social card and structured data for the page in view.
// The edge (functions/merch) renders the same tags into the HTML for
// crawlers; this keeps them right while someone browses the SPA.

const SITE = "https://thecreaksofficial.com";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (content == null || content === "") {
    if (el?.dataset.shop) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    el.dataset.shop = "1";
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!href) {
    if (el?.dataset.shop) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("link");
    el.rel = rel;
    el.dataset.shop = "1";
    document.head.appendChild(el);
  }
  el.href = href;
}

export default function useSeo({ title, description, image, path, type = "website", noindex = false, jsonLd = null }) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    const prevTitle = document.title;
    const full = title ? `${title} | The Creaks Merch` : "Merch | The Creaks";
    document.title = full;
    const desc = description ? String(description).replace(/\s+/g, " ").trim().slice(0, 160) : null;
    const url = path ? `${SITE}${path}` : null;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:image", image);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", type);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "robots", noindex ? "noindex, follow" : null);
    setLink("canonical", url);
    let script = document.getElementById("shop-ld");
    if (ld) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "shop-ld";
        document.head.appendChild(script);
      }
      script.textContent = ld;
    } else if (script) script.remove();
    return () => {
      document.title = prevTitle;
    };
  }, [title, description, image, path, type, noindex, ld]);
}

export const absolute = (path) => `${SITE}${path}`;
